import { storeToRefs } from "pinia";

import { useNotificationStore } from "@/stores/modules/notification";

export const useNotification = () => {
  const notificationStore = useNotificationStore();
  const { notifications, preferences } = storeToRefs(notificationStore);

  const getNotifications = async data => {
    let params = {
      unset_new: true
    };
    await notificationStore.getNotifications(params);
  };
  const updateNotification = async data => {
    let params = {
      id: data.id,
      status: data.status
    };
    await notificationStore.updateNotification(params);
  };
  const readAllNotification = async data => {
    let params = {
      status: data.status
    };
    await notificationStore.readAllNotification(params);
  };

  const getNotificationPreferences = async () =>
    await notificationStore.getNotificationPreferences();

  const updateNotificationPreferences = async payload => {
    await notificationStore.updateNotificationPreferences(payload);
  };

  return {
    //! Properties
    preferences,
    notifications,

    //! Metodos
    getNotifications,
    updateNotification,
    readAllNotification,
    getNotificationPreferences,
    updateNotificationPreferences
  };
};
